import React from "react";

export function Logo({ size = 36, withText = true }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="stack-logo">
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-label="STACK logo">
        <defs>
          <linearGradient id="stack-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0066FF" />
            <stop offset="100%" stopColor="#00F0FF" />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="1.6" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <g filter="url(#glow)">
          <path d="M8 30 L24 38 L40 30 L24 22 Z" fill="url(#stack-grad)" opacity="0.95" />
          <path d="M8 22 L24 30 L40 22 L24 14 Z" fill="url(#stack-grad)" opacity="0.7" />
          <path d="M8 14 L24 22 L40 14 L24 6 Z" fill="url(#stack-grad)" opacity="0.45" />
        </g>
      </svg>
      {withText && (
        <div className="leading-tight">
          <div className="heading-font text-xl font-extrabold tracking-tight text-white">
            STACK
          </div>
          <div className="text-[10px] uppercase tracking-widest text-cyan-400/80 -mt-0.5">
            10-min delivery
          </div>
        </div>
      )}
    </div>
  );
}
